import React, { PropsWithChildren } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface SectionProps {
  label: string;
  valueText?: string;
  open: boolean;
  onToggle: () => void;
}

export default function Section({
  label, valueText, open, onToggle, children,
}: PropsWithChildren<SectionProps>) {
  return (
    <div className="control-panel-sheet-section">
      <button
        type="button"
        className="control-panel-sheet-section-header"
        aria-expanded={open}
        onClick={onToggle}
      >
        <span className="control-panel-sheet-section-label">{label}</span>
        {valueText && <span className="control-panel-sheet-section-value">{valueText}</span>}
        <Icon
          iconType={open ? 'down_arrow' : 'right_arrow'}
          color={cssVar(open ? 'text-accent' : 'text-muted')}
          className="control-panel-sheet-section-chevron"
        />
      </button>
      {open && <div className="control-panel-sheet-section-body">{children}</div>}
    </div>
  );
}
